import React from "react";

const MessageA42 = (props) => {
  let data = props.item && props.item.text_data && props.item.text_data.html;

  return (
    <div
      style={{ margin: "10px 0px" }}
      dangerouslySetInnerHTML={{ __html: data }}
    ></div>
  );
};

export default MessageA42;
